import { useMutation } from "@tanstack/react-query";
import { removeGoogleAdsAccount } from "../../api/bGoogleAdsApi";

export const useRemoveGoogleAdsAccount = () => {
  return useMutation({
    mutationKey: ["remove-google-ads-account"],
    mutationFn: (data) => removeGoogleAdsAccount(data),
    onError: (error) => {
      console.error("Remove Google Ads account error:", error?.response || error);
    },
  });
};
